import Link from 'next/link'
import { CheckCircle2, TrendingUp, Clock, ChevronRight } from 'lucide-react'

const SIGNUP_URL = '/auth/login'

const HERO_STATS = [
  { icon: TrendingUp, value: '40%',   label: 'menos burocracia' },
  { icon: Clock,      value: '10min', label: 'para configurar e usar' },
]

export function HeroSection() {
  return (
    <section
      aria-label="Apresentação"
      style={{
        position: 'relative',
        height: '100svh',
        minHeight: 640,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-end',
        padding: '0 24px 56px',
        overflow: 'hidden',
        background: '#0A1A10',
      }}
    >
      {/* ── Gradiente radial decorativo ── */}
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          background: `
            radial-gradient(ellipse 80% 60% at 60% 20%, rgba(26,92,46,0.55) 0%, transparent 65%),
            radial-gradient(ellipse 60% 80% at 20% 80%, rgba(58,140,86,0.18) 0%, transparent 60%)
          `,
          zIndex: 1,
        }}
      />

      {/* ── Grid texture ── */}
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: 1,
          backgroundImage: `
            linear-gradient(rgba(255,255,255,0.025) 1px, transparent 1px),
            linear-gradient(90deg, rgba(255,255,255,0.025) 1px, transparent 1px)
          `,
          backgroundSize: '48px 48px',
          pointerEvents: 'none',
        }}
      />

      {/* ── Gradiente inferior para texto ── */}
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          background: 'linear-gradient(to top, rgba(10,26,16,0.98) 0%, rgba(10,26,16,0.50) 50%, transparent 100%)',
          zIndex: 2,
        }}
      />

      {/* ── Conteúdo ── */}
      <div
        style={{
          position: 'relative',
          zIndex: 3,
          maxWidth: 460,
          margin: '0 auto',
          width: '100%',
        }}
      >
        {/* Badge */}
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 7,
            padding: '6px 14px',
            borderRadius: 50,
            background: 'rgba(82,201,126,0.12)',
            border: '1px solid rgba(82,201,126,0.22)',
            marginBottom: 22,
          }}
        >
          <CheckCircle2 size={12} color="#52C97E" />
          <span
            style={{
              fontSize: 11,
              color: '#52C97E',
              fontWeight: 700,
              letterSpacing: '0.06em',
              textTransform: 'uppercase',
            }}
          >
            Mais controle para sua operação
          </span>
        </div>

        {/* Headline */}
        <h1
          style={{
            fontFamily: 'var(--font-bricolage)',
            fontSize: 'clamp(30px, 9vw, 42px)',
            fontWeight: 800,
            color: '#fff',
            lineHeight: 1.08,
            letterSpacing: '-0.03em',
            marginBottom: 18,
          }}
        >
          Financeiro, agenda e gestão de pilotos na palma da{' '}
          <span style={{ color: '#52C97E' }}>MÃO.</span>
        </h1>

        {/* Subheadline */}
        <p
          style={{
            fontSize: 15,
            color: 'rgba(255,255,255,0.58)',
            lineHeight: 1.75,
            marginBottom: 32,
            maxWidth: 380,
          }}
        >
          Profissionalize sua operação com mais controle e eficiência. Um app feito por operadores de drones agrícolas.
        </p>

        {/* CTA principal */}
        <Link
          href={SIGNUP_URL}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 7,
            width: '100%',
            background: '#3A8C56',
            color: '#fff',
            padding: '16px 24px',
            borderRadius: 14,
            fontWeight: 700,
            fontSize: 15,
            fontFamily: 'var(--font-jakarta)',
            textDecoration: 'none',
            boxShadow: '0 4px 28px rgba(58,140,86,0.42)',
            marginBottom: 32,
          }}
        >
          Criar conta grátis <ChevronRight size={16} strokeWidth={2.5} />
        </Link>

        {/* Stats */}
        <div
          style={{
            display: 'flex',
            gap: 28,
            paddingTop: 24,
            borderTop: '1px solid rgba(255,255,255,0.08)',
          }}
        >
          {HERO_STATS.map(({ icon: Icon, value, label }, i) => (
            <div key={i} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <Icon size={15} color="#52C97E" />
              <div>
                <div
                  style={{
                    fontFamily: 'var(--font-bricolage)',
                    fontSize: 21,
                    fontWeight: 800,
                    color: '#fff',
                    lineHeight: 1,
                  }}
                >
                  {value}
                </div>
                <div style={{ fontSize: 11, color: 'rgba(255,255,255,0.38)', marginTop: 3 }}>
                  {label}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
